import React from 'react';

interface RequiredLabelProps {
  children: React.ReactNode;
  htmlFor?: string;
}

const RequiredLabel: React.FC<RequiredLabelProps> = ({ children, htmlFor }) => {
  return (
    <label htmlFor={htmlFor}>
      {children} <span style={{ color: 'red' }}>*</span>
    </label>
  );
};

export default RequiredLabel;